<template>
    <v-container>
        <v-row class="fill-height">
            <v-col>
                <v-sheet height="64">
                    <v-toolbar flat>
                        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                            {{ trans('common.calendar.today') }}
                        </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="prev">
                            <v-icon small>
                                navigate_before
                            </v-icon>
                        </v-btn>
                        <v-btn fab text small color="grey darken-2" @click="next">
                            <v-icon small>
                                navigate_next
                            </v-icon>
                        </v-btn>
                        <v-toolbar-title v-if="$refs.calendar">
                            {{ $refs.calendar.title }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-menu bottom right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                                    <span>{{ typeToLabel[type] }}</span>
                                    <v-icon right>
                                        mdi-menu-down
                                    </v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="type = 'day'">
                                    <v-list-item-title>{{ trans('common.calendar.day') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = 'week'">
                                    <v-list-item-title>{{ trans('common.calendar.week') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = 'month'">
                                    <v-list-item-title>{{ trans('common.calendar.month') }}</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="type = '4day'">
                                    <v-list-item-title>{{ trans('common.calendar.4days') }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>
                </v-sheet>
                <v-sheet height="600">
                    <v-calendar ref="calendar" v-model="focus" color="primary" :events="events" :event-color="getEventColor"
                        :type="type" @click:event="showEvent" @click:more="viewDay" @click:date="viewDay"
                        @change="updateRange"></v-calendar>
                    <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
                        <v-card color="grey lighten-4" min-width="350px" flat>
                            <v-toolbar :color="selectedEvent.color" dark>

                                <!--
                                <v-btn icon>
                                     <v-icon v-if="selectedEvent.type =='W'">edit</v-icon>
                                </v-btn>
                                -->
                                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <!--
                                <v-btn icon>
                                    <v-icon>cancel</v-icon>
                                </v-btn>

                                <v-btn icon>
                                    <v-icon>cancel</v-icon>
                                </v-btn>
                                -->
                            </v-toolbar>
                            <v-card-text>
                                <span v-html="selectedEvent.details"></span>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn text color="secondary" @click="selectedOpen = false">
                                    {{ trans('common.close') }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>


export default {

    name: "target-calendar",

    props: {
        target_calendar_action: { default: ''}

    },
    data() {

        return {
            focus: '',
            type: 'month',
            typeToLabel: {
                month: trans('common.calendar.month'),
                week: trans('common.calendar.week'),
                day: trans('common.calendar.day'),
                '4day': trans('common.calendar.4days'),
            },
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            events: [],
            colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        }
    },

    mounted() {
        this.$refs.calendar.checkChange()
    },
    methods: {
        viewDay({ date }) {
            this.focus = date
            this.type = 'day'
        },
        getEventColor(event) {
            return event.color
        },
        setToday() {
            this.focus = ''
        },
        prev() {
            this.$refs.calendar.prev()
        },
        next() {
            this.$refs.calendar.next()
        },
        showEvent({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = nativeEvent.target
                requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                open()
            }

            nativeEvent.stopPropagation()
        },

        async getTargetCalendarResults(start_date, end_date) {
            let route = this.target_calendar_action + '/' + start_date + '/' + end_date;
            let result = await axios.get(route);
            return result;
        },

        async updateRange({ start, end }) {
            const events = []

            // const min = new Date(`${start.date}T00:00:00`)
            // const max = new Date(`${end.date}T23:59:59`)
            // const days = (max.getTime() - min.getTime()) / 86400000
            // const eventCount = this.rnd(days, days + 20)


            let result = await this.getTargetCalendarResults(start.date, end.date);

            let records = result.data;

            for(let record of records) {
                let target_name             = record.name;
                let target_deadline         = record.deadline;
                // let target_date             = new Date(target_deadline);
                let min_started             = (record.min_started !== undefined) ? record.min_started : null;
                let max_ended               = (record.max_ended !== undefined) ? record.max_ended : null;

                let target_allocated_time   = record.allocated_time;
                let target_priority         = record.priority;
                let target_type             = record.type;
                let target_hourly_budget    = record.hourly_budget;

                let real_start              = (min_started !== null) ? min_started : target_deadline;
                let real_end                = (max_ended !== null) ? max_ended : target_deadline;

                let calendar_color = 'purple';
                if(target_type == 'W') {

                    calendar_color = '#81D4FA';
                    if(target_priority == '2') {
                        calendar_color = '#00BCD4';
                    } else if(target_priority == '3') {
                        calendar_color = 'blue';
                    }

                }


                let detail_type = '<li>' + trans('targets.fields.type') + ': ' + trans('targets.values.type.'+target_type)  + '</li>';
                let detail_priority = '<li>' + trans('targets.fields.priority') + ': ' + trans('targets.values.priority.'+target_priority)  + '</li>';
                let detail_allocated_time = '<li>' + trans('targets.fields.allocated_time') + ': ' + target_allocated_time  + '</li>';
                let target_detail = '<ul>' + detail_type + detail_priority + detail_allocated_time + '</ul>';




                events.push({
                    name: target_name,
                    start: real_start,
                    end: real_end,
                    color: calendar_color,
                    timed: true,
                    details: target_detail
                });
            }

            this.events = events
        },
        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a
        },
    },
}

</script>
